import React, { ReactElement } from 'react';
import ReactDOM from 'react-dom';
import Slider, { Settings } from 'react-slick';
import SimilarBreedCard, { SimilarBreedCardInterface } from '../card/similar-breed-card';

interface SimilarBreedsProps {
  breeds: SimilarBreedCardInterface[];
  listingType: string;
}

const SimilarBreeds: React.FC<SimilarBreedsProps> = ({ breeds, listingType }): ReactElement => {
  const sliderSettings: Settings = {
    infinite: false,
    arrows: false,
    responsive: [
      {
        // Disable slider at screen widths above 991 px. Unfortunately, slick
        // only allows 'unslick' in ResponsiveObject, so the best way is to
        // set the breakpoint higher than any screen width. See:
        // https://stackoverflow.com/a/46214551
        breakpoint: 10000000,
        settings: 'unslick',
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '60px',
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '30px',
        },
      },
    ],
  };

  return (
    <>
      <section className="similar-breeds-section">
        <div className="similar-breeds-container">
          <h3>Similar Breeds</h3>
          <Slider {...sliderSettings}>
            {breeds.map((breed) => (
              <SimilarBreedCard
                listingType={listingType}
                key={breed.id}
                breed={breed}
              />
            ))}
          </Slider>
        </div>
      </section>
    </>
  );
};

export default SimilarBreeds;

if (document.getElementsByClassName('similar-breeds').length > 0) {
  const element = document.getElementsByClassName('similar-breeds')[0];
  const breeds = JSON.parse(element.getAttribute('data-breeds') ?? '');
  const listingType = element.getAttribute('data-listing-type') ?? '';
  ReactDOM.render(<SimilarBreeds listingType={listingType} breeds={breeds} />, element);
}
